var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"toggle",attrs:{"type":"checkbox","role":"switch"},domProps:{"checked":_vm.checked},on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }